import { useSelector } from "react-redux";

export default function Theme({ ticket }) {
  const theme = useSelector((state) => state.venues[ticket.venue.id]);

  if (theme) {
    return (
      <div
        className="w-full h-full flex items-center justify-center"
        style={{ background: theme.accent }}
      >
        <img
          className="-rotate-90 origin-center w-auto h-auto"
          style={{ maxWidth: "8.5rem", maxHeight: "2rem" }}
          src={`/img/venues/${theme.img}`}
          alt={`Branding for ${ticket.venue.name}`}
        />
      </div>
    );
  } else {
    return <div className="border-r-4 border-gray-500" />;
  }
}
